import { useLogo } from "../../brand";
import { useDispatch, useSelector } from "react-redux";
import { selectTranslations } from "../../services/i18n/i18nSlice";
import { useLocation, useParams } from "react-router";
import { useEffect, useState, useRef } from "react";
import { setLoading, setNavbarHide, setNavbarHideMobile } from "../../services/global/globalSlice";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import arrow_img from '../../assets/images/arrow-back.svg'
import direction_img from '../../assets/images/exams/directions.svg'
import completed_step_img from '../../assets/images/exams/completed.svg'
import proctoring_step from '../../assets/images/exams/proctoring_step.svg'
import certificate_step from '../../assets/images/exams/certificate_step.svg'
import generic_step from '../../assets/images/exams/generic_step.svg'

import { TitleH1 } from "../../components/TitleH1";
import { selectAppInfo } from "../../services/utils/appInfoSlice";
import { selectUserData } from "../../features/User/userSlice";
import { fetchGetDetailedExam } from "./ExamsApi";
import { showError } from "../../features/Error/errorSlice";
import { API_URL } from "../../config/constants";
import { Text } from "../../components/Text";
import { Button } from "../../components/Button";

export default function ExamSATResultsScreen(){
    const logo = useLogo()

    const [examData, setExamData] = useState(null)
    const [step, setStep] = useState(0)
    const [examId, setExamId] = useState("")

    const appInfo = useSelector(selectAppInfo)
    const userInfo = useSelector(selectUserData)
    

    const {user_exam_id} = useParams()

    const t = useSelector(selectTranslations)
    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [showThresholdSheet, setShowThresholdSheet] = useState(false)

    const closeThresholdSheet = (_,redirect = true) =>{
        if(redirect)
            navigate('/',{replace: true})
        setShowThresholdSheet(false)
    }

    const loadExamData = async () => {
        const response = await fetchGetDetailedExam({user_exam_id:user_exam_id})
        if(response.success){
            let _examData = response.data
            setExamData(_examData)
            dispatch(setLoading(false))
        } else {
            dispatch(showError({
                title: t.exam.errors.start,
                text: t.exam.errors.start_text,
                redirect: "/exams"
            }))
        }
    }

    useEffect(() => {
        dispatch(setNavbarHideMobile(true))
        dispatch(setNavbarHide(true))
        loadExamData()
    }, [location])

    const totalTime = () => {
        let _total = 0
        examData?.modules?.forEach((m)=>
            _total += m.consumed_time
        )
        return _total
    }

    const formatTime = (time) => {
        return String(time).padStart(2, '0')
    }

    return (
        <section id="examPreviewScreen">
            <div className='section_header d-flex justify-content-between align-items-center'>
                <Link to={'/exams/history'} style={{width:'20%'}}><img src={arrow_img} className='pointer' alt=""/></Link>
                <div style={{ overflow:'hidden'}}>
                    <img src={logo}  className="d-block h-100"/>
                </div>
                <Link to={'/account/contact'} style={{width:'20%'}} className="text-end">{t.account.need_help}</Link>
            </div>
            <div className="text-center mt-3" >
                <img src={direction_img} />
                <TitleH1>{t.exam.next_steps}</TitleH1>
                <Text>{t.exam.result_next_steps_text}</Text>
            </div>
            <div className="step ">
                <ul className="next_steps extended">
                    <li className="first">
                        <img src={completed_step_img} />
                        <Text className="mb-0">{t.exam.results_steps.completed_test}</Text>
                    </li>
                    <li className={examData?.state === 'completed' ? 'first' : ''}>
                        <img src={examData?.state === 'completed' ? completed_step_img : proctoring_step} />
                        <Text className="mb-0">{examData?.state === 'completed' ? t.exam.results_steps.revision_completed : t.exam.results_steps.revision_in_progress}</Text>
                    </li>
                    {
                        examData?.thresholds?.find(t => t.threshold_type === "certificate_generation") &&
                        <li className="align-items-start">
                            <img src={certificate_step} />
                            <div>
                                <Text className="mb-0">{t.exam.results_steps.download_certificate}</Text>
                                <a href={examData?.certificate_pdf_url || ''} target="_blank" disabled={!examData?.certificate_pdf_url} download={true}>
                                    <Button disabled={!examData?.certificate_pdf_url} className="mt-2">
                                        {t.exam.results_steps.download}
                                    </Button>
                                </a>
                            </div>
                            
                        </li>
                    }
                    
                    {
                        examData?.additional_results_step?.map((step,index)=>{
                            return (
                                <li key={index} className={step?.cta?.url ? "align-items-start" : ''}>
                                    <img src={step.icon_url ? `${API_URL}${step.icon_url}` : generic_step} />
                                    <div>
                                        <Text className="mb-0">{step.text}</Text>
                                        {
                                            step?.cta?.url && 
                                            <a href={step?.cta?.url} target="_blank" >
                                                <Button className="mt-2">
                                                {step?.cta?.text || t.exam.open_link}
                                                </Button>
                                            </a>
                                        }
                                    </div>
                                </li>
                            )
                        })
                    }

                    
                    
                </ul>
            </div>
        </section>
    )
}